<template>
  <form @submit.prevent="saveCategory">
    <div class="row">
      <div class="col-lg-12">
        <div class="mb-3">
          <label class="form-label">Category Name</label>
          <input
            v-model="form.name"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            placeholder="name"
          >
          <div v-if="errors.name" class="invalid-feedback">
            {{ errors.name[0] }}
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="edit-add card">
          <div class="edit-add">
            <label class="form-label">Description</label>
          </div>
          <div class="card-body-list input-blocks mb-0">
            <textarea
              v-model="form.description"
              class="form-control"
              :class="{ 'is-invalid': errors.description }"
              rows="3"
            ></textarea>
            <div v-if="errors.description" class="invalid-feedback">
              {{ errors.description[0] }}
            </div>
          </div>
          <p>Maximum 600 Characters</p>
        </div>
      </div>
    </div>
    <div class="modal-footer-btn">
      <a href="javascript:void(0);" class="btn btn-cancel me-2" data-bs-dismiss="modal">
        Cancel
      </a>
      <button type="submit" class="btn btn-submit" :disabled="loading">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ isEditMode ? 'Update' : 'Submit' }}
      </button>
    </div>
  </form>
</template>

<script>
import { showSuccessMessage, showErrorMessage } from '../utils/notifications.js';

export default {
  name: 'ExpenseCategoryManager',

  props: {
    categoryId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
      errors: {},
      loading: false,
      isEditMode: false
    };
  },

  async mounted() {
    console.log('ExpenseCategoryManager component mounted');
    console.log('Category ID:', this.categoryId);

    // Mark element as mounted
    this.$el.closest('[data-vue-component]')?.classList.add('vue-mounted');

    if (this.categoryId) {
      await this.loadCategory();
    }
  },

  methods: {
    async loadCategory() {
      try {
        const response = await this.$http.get(`/api/expense-categories/${this.categoryId}`);

        if (response.data.success) {
          const category = response.data.category;
          this.form = {
            name: category.name,
            description: category.description || ''
          };
          this.isEditMode = true;
        } else {
          this.showErrorMessage('Failed to load category data');
        }
      } catch (error) {
        console.error('Failed to load category:', error);
        this.showErrorMessage('Failed to load category data');
      }
    },

    async saveCategory() {
      this.loading = true;
      this.errors = {};

      try {
        let response;

        if (this.isEditMode) {
          response = await this.$http.put(`/api/expense-categories/${this.categoryId}`, this.form);
        } else {
          response = await this.$http.post('/api/expense-categories', this.form);
        }

        if (response.data.success) {
          this.showSuccessMessage(response.data.message);

          // Close modal and refresh page
          setTimeout(() => {
            const modal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
            if (modal) {
              modal.hide();
            }
            window.location.reload();
          }, 1500);
        } else {
          this.showErrorMessage(response.data.message || 'Failed to save category');
        }

      } catch (error) {
        console.error('Category save failed:', error);

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.showErrorMessage('Please check the form for errors');
        } else {
          this.showErrorMessage(
            error.response?.data?.message || 'An error occurred while saving the category'
          );
        }
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        name: '',
        description: ''
      };
      this.errors = {};
      this.isEditMode = false;
    },

    editCategory(categoryId) {
      this.categoryId = categoryId;
      this.loadCategory();
    },

    showSuccessMessage,
    showErrorMessage
  },

  watch: {
    categoryId(newId) {
      if (newId) {
        this.loadCategory();
      } else {
        this.resetForm();
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.vue-component-loading {
  display: none;
}
</style>
